import React from 'react';
import { useTranslation } from 'react-i18next';
import Pill from 'components/Pill';
import Icon from 'components/Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function NextUpPill() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Pill, {
    background: "highlight",
    children: [/*#__PURE__*/_jsx(Icon, {
      vAlign: true,
      dimmed: true,
      name: "nav-right",
      scale: 0,
      mr: "xxxs"
    }), t('asset_next_up')]
  });
}